import { createTheme, Theme } from '@mui/material';

export const theme: Theme = createTheme({
  typography: {
    fontSize: 14,
    fontFamily: 'DMSansLight',
  },
  palette: {
    primary: {
      main: '#02004D',
      light: '#dce9e9',
      dark: '#2C3333',
    },
  },
});

